import { render, staticRenderFns } from "./PageSettleWait.vue?vue&type=template&id=bab8c048&scoped=true"
import script from "./PageSettleWait.vue?vue&type=script&lang=js"
export * from "./PageSettleWait.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab8c048",
  null
  
)

export default component.exports